import { takeLatest, call, all, put, fork } from 'redux-saga/effects'

import * as actions from '../../actions/actions'

import {files, approve, send, upload, download, reupload} from "../../../api/fileApi"
import {push} from "connected-react-router";

export default function* fileSaga() {
  yield all([
    fork(watchFetchFileRequest),
    fork(watchApproveFileRequest),
    fork(watchSendFileRequest),
    // fork(watchApproveOTPSubmitRequest),
    fork(watchFileUploadRequest),
    fork(watchFileUploadFileFieldChangeRequest),
    fork(watchFileUploadContoCorrenteFieldChangeRequest),
    fork(watchFileUploadCampaignFieldChangeRequest),
    fork(watchFileUploadCleanRequest),
    fork(watchFileErrorDownloadRequest),
    fork(watchFileReUploadRequest)
  ]);
}

function* watchSendFileRequest() {
  yield takeLatest(
    actions.SEND_FILE_REQUEST,
    sendFileRequest
  )
}

function* sendFileRequest(fileId) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(send, fileId.value)
    yield put({ type: actions.SEND_FILE_SUCCESS, file: data })
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.SEND_FILE_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchFetchFileRequest() {
  yield takeLatest(
    actions.FETCH_FILES_REQUEST,
    fetchFilesRequest
  )
}

function* fetchFilesRequest() {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(files)
    yield put({ type: actions.FETCH_FILES_SUCCESS, files: data })
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.FETCH_FILES_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }else if(error.request)
    {
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }
  }
}

function* watchApproveFileRequest() {
  yield takeLatest(
      actions.APPROVE_FILE_REQUEST,
      approveFileRequest
  )
}

function* approveFileRequest(file) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(approve, file.value.bankId, file.value.file)
    yield put({ type: actions.APPROVE_FILE_SUCCESS, files: data })
    yield put({ type: actions.FETCH_FILES_REQUEST })
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.APPROVE_FILE_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
      yield put(push(`/file`))
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }else if(error.request)
    {
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
      yield put(push(`/file`))
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }
  }
}

function* watchFileUploadContoCorrenteFieldChangeRequest() {
  yield takeLatest(
      actions.FILE_UPLOAD_CONTO_CORRENTE_FILED_CHANGE_REQUEST,
      fileUploadContoCorrenteFieldChangeRequest
  )
}

function* fileUploadContoCorrenteFieldChangeRequest(contoCorrente) {
  yield put({ type: actions.FILE_UPLOAD_CONTO_CORRENTE_FILED_CHANGE, value: contoCorrente.value })
}

function* watchFileUploadCampaignFieldChangeRequest() {
  yield takeLatest(
      actions.FILE_UPLOAD_CAMPAIGN_FILED_CHANGE_REQUEST,
      fileUploadCampaignFieldChangeRequest
  )
}

function* fileUploadCampaignFieldChangeRequest(campaignId) {
  yield put({ type: actions.FILE_UPLOAD_CAMPAIGN_FILED_CHANGE, value: campaignId.value })
}

function* watchFileUploadRequest() {
  yield takeLatest(
      actions.FILE_UPLOAD_REQUEST,
      fileUploadRequest
  )
}

function* fileUploadRequest(fileData) {
  yield put({type: actions.CLEAN_ERROR})
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(upload, fileData.value)
    if (data.outcome === "SUCCESSFUL_UPLOAD"){
      yield put({ type: actions.FILE_UPLOAD_SUCCESS, value: data })
      yield put({ type: actions.PROGRESS_START_REQUEST })
      yield put({ type: actions.FILE_UPLOAD_CLEAN})
      yield put({ type: actions.FETCH_FILES_REQUEST })
      yield put(push(`/file`))
      yield put({ type: actions.TOGGLE_POSITIVE_UPLOAD_MODAL, value: data })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } else if (data.outcome === "NOT_SUCCESSFUL_UPLOAD") {
      yield put({ type: actions.FILE_UPLOAD_FAILURE, value: data})
      yield put({ type: actions.PROGRESS_START_REQUEST })
      yield put({ type: actions.FILE_UPLOAD_CLEAN })
      yield put({ type: actions.FETCH_FILES_REQUEST })
      yield put(push(`/file`))
      yield put({ type: actions.TOGGLE_NEGATIVE_UPLOAD_MODAL, value: data })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } else if(data.outcome === "FILE_EMPTY") {
      yield put({ type: actions.FILE_UPLOAD_FAILURE, value: data})
      yield put({ type: actions.PROGRESS_START_REQUEST })
      yield put({ type: actions.FILE_UPLOAD_CLEAN })
      yield put({ type: actions.FETCH_FILES_REQUEST })
      yield put(push(`/file`))
      yield put({ type: actions.TOGGLE_EMPTY_UPLOAD_MODAL, value: data })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } else if(data.outcome === "FILE_ROW_LIMIT") {
      yield put({ type: actions.FILE_UPLOAD_FAILURE, value: data})
      yield put({ type: actions.PROGRESS_START_REQUEST })
      yield put({ type: actions.FILE_UPLOAD_CLEAN })
      yield put({ type: actions.FETCH_FILES_REQUEST })
      yield put(push(`/file`))
      yield put({ type: actions.TOGGLE_FILE_ROW_LIMIT_UPLOAD_MODAL, value: data })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } else {
      yield put({ type: actions.FILE_UPLOAD_SUCCESS, value: data })
      yield put({ type: actions.PROGRESS_START_REQUEST })
      yield put({type: actions.FILE_UPLOAD_CLEAN })
      yield put({ type: actions.FETCH_FILES_REQUEST })
      yield put(push(`/file`))
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }
  } catch (error) {
    if(error.response) {
      yield put({ type: actions.FILE_UPLOAD_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
      yield put({ type: actions.FETCH_FILES_REQUEST })
      yield put(push(`/file`))
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }else if(error.request) {
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
      yield put({ type: actions.FETCH_FILES_REQUEST })
      yield put(push(`/file`))
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }
  }
}

function* watchFileUploadFileFieldChangeRequest() {
  yield takeLatest(
      actions.FILE_UPLOAD_FILE_FILED_CHANGE_REQUEST,
      fileUploadFileFieldChangeRequest
  )
}

function* fileUploadFileFieldChangeRequest(file) {
  yield put({ type: actions.FILE_UPLOAD_FILE_FILED_CHANGE, value: file.value })
}

function* watchFileErrorDownloadRequest() {
  yield takeLatest(
      actions.DOWNLOAD_ERROR_FILE_REQUEST,
      fileErrorDownloadRequest
  )
}

function* fileErrorDownloadRequest(file) {
  let fileName = file.value.header.substring(file.value.header.lastIndexOf("=") + 1)
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(download, file)
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName); //change name
    document.body.appendChild(link);
    link.click();
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response) {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } else if(error.request) {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }
  }
}

function* watchFileUploadCleanRequest() {
  yield takeLatest(
      actions.FILE_UPLOAD_CLEAN_REQUEST,
      fileUploadCleanRequest
  )
}

function* fileUploadCleanRequest(file) {
  yield put({ type: actions.FILE_UPLOAD_CLEAN })
}

function* watchFileReUploadRequest() {
  yield takeLatest(
      actions.FILE_REUPLOAD_REQUEST,
      fileReUploadRequest
  )
}

function* fileReUploadRequest(fileData) {
  yield put({type: actions.CLEAN_ERROR})
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(reupload, fileData.value)
    if (data.outcome === "SUCCESSFUL_UPLOAD"){
      yield put({ type: actions.FILE_UPLOAD_SUCCESS, value: data })
      yield put({ type: actions.PROGRESS_START_REQUEST })
      yield put({ type: actions.FILE_UPLOAD_CLEAN})
      yield put({ type: actions.FETCH_FILES_REQUEST })
      yield put(push(`/file`))
      yield put({ type: actions.TOGGLE_POSITIVE_UPLOAD_MODAL, value: data })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } else if (data.outcome === "NOT_SUCCESSFUL_UPLOAD") {
      yield put({ type: actions.FILE_UPLOAD_FAILURE, value: data})
      yield put({ type: actions.PROGRESS_START_REQUEST })
      yield put({ type: actions.FILE_UPLOAD_CLEAN })
      yield put({ type: actions.FETCH_FILES_REQUEST })
      yield put(push(`/file`))
      yield put({ type: actions.TOGGLE_NEGATIVE_UPLOAD_MODAL, value: data })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } else if(data.outcome === "FILE_EMPTY") {
      yield put({ type: actions.FILE_UPLOAD_FAILURE, value: data})
      yield put({ type: actions.PROGRESS_START_REQUEST })
      yield put({ type: actions.FILE_UPLOAD_CLEAN })
      yield put({ type: actions.FETCH_FILES_REQUEST })
      yield put(push(`/file`))
      yield put({ type: actions.TOGGLE_EMPTY_UPLOAD_MODAL, value: data })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } else if(data.outcome === "FILE_ROW_LIMIT") {
      yield put({ type: actions.FILE_UPLOAD_FAILURE, value: data})
      yield put({ type: actions.PROGRESS_START_REQUEST })
      yield put({ type: actions.FILE_UPLOAD_CLEAN })
      yield put({ type: actions.FETCH_FILES_REQUEST })
      yield put(push(`/file`))
      yield put({ type: actions.TOGGLE_FILE_ROW_LIMIT_UPLOAD_MODAL, value: data })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } else {
      yield put({ type: actions.FILE_UPLOAD_SUCCESS, value: data })
      yield put({ type: actions.PROGRESS_START_REQUEST })
      yield put({type: actions.FILE_UPLOAD_CLEAN })
      yield put({ type: actions.FETCH_FILES_REQUEST })
      yield put(push(`/file`))
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }
  } catch (error) {
    if(error.response) {
      yield put({ type: actions.FILE_UPLOAD_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
      yield put({ type: actions.FETCH_FILES_REQUEST })
      yield put(push(`/file`))
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } else if(error.request) {
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
      yield put({ type: actions.FETCH_FILES_REQUEST })
      yield put(push(`/file`))
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }
  }
}